import { purchasedProductsStyles as styles } from "@insite/content-library/Widgets/Common/PurchasedProducts";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.titleText = {
    ...styles.titleText,
    css: css`
        ${styles.titleText?.css}
        margin-bottom: 8px;

        ${mediaQueriesBP.minMD} {
            margin-bottom: 24px;
        }
    `,
};

styles.headerContainer = {
    ...styles.headerContainer,
    css: css`
        ${styles.headerContainer?.css}
        padding: 16px;
    `,
    offsetCss: css`
        ${styles.headerContainer?.offsetCss}
        flex-wrap: nowrap !important;
        gap: 16px;
    `,
};

styles.priceHeaderGridItem = {
    ...styles.priceHeaderGridItem,
    css: css`
        ${styles.priceHeaderGridItem?.css}
        padding: 0;
    `,
};

styles.addToCartHeaderGridItem = {
    ...styles.addToCartHeaderGridItem,
    css: css`
        ${styles.addToCartHeaderGridItem?.css}
        justify-content: flex-start;
        padding: 0;
    `,
};
